export default __webpack_public_path__ + "static/media/resort.ee8c04b6.jpg";